module.exports = __webpack_public_path__ + "img/4.8ea5d9c8.jpg";